import api from "@/api/api-v2-config";

export async function getVehicleListAxios() {    
    return await api.get("distributions/vehicles?PageNumber=1&PageSize=1000");
}

export async function deleteVehicleAxios(id) {    
    return await api.delete("distributions/vehicles?VehicleId=" + id);
}

export async function postVehicleAxios(vehicle) {    
    return await api.post("distributions/vehicles", vehicle);
}

export async function putVehicleAxios(vehicle) {    
    return await api.put("distributions/vehicles", vehicle);
}

export async function getVehicleByIDAxios(id) {    
    return await api.get("distributions/vehiclebyid?vehicleid=" + id);
}